export default __webpack_public_path__ + "static/media/laptop1.883312d0.jpg";